<template>
  <el-scrollbar class="scroll-bar">
    <el-tree
      ref="tree"
      class="tree-content"
      :data="treeData"
      :expand-on-click-node="false"
      node-key="integratedGroupCode"
      :default-expanded-keys="expandedKeys"
      render-after-expand
      :props="treeProps"
      :default-expand-all="true"
      :highlight-current="true"
      @node-click="handleNodeClick"
    >
      <!-- :filter-node-method="filterNode" -->
      <template slot-scope="{ node, data }">
        <element-tree-line
          :node="node"
          :showLabelLine="true"
          :indent="16"
          class="tree-line"
        >
          <span class="custom-tree-node">
            <span
              :title="node.label"
              class="tree-label"
              :class="data.integratedGroupCode === currentNode ? 'hide' : ''"
              >{{ node.label }}</span
            >
            <span
              v-if="data.integratedGroupCode === currentNode"
              class="tree-btn"
            >
              <div class="area-operator" @click="stop">
                <el-button
                  type="text"
                  class="el-icon-plus"
                  size="mini"
                  v-auth="'/workshop/emergency-group:add'"
                  @click="() => addGroup(node, data)"
                  title="新增"
                ></el-button>
                <el-button
                  type="text"
                  class="el-icon-edit-outline"
                  size="mini"
                  v-auth="'/workshop/emergency-group:update'"
                  @click="() => editGroup(node, data)"
                  title="修改"
                ></el-button>
                <el-button
                  v-if="data.parentCode !== '-1'"
                  type="text"
                  class="el-icon-delete-solid"
                  size="mini"
                  v-auth="'/workshop/emergency-group:delete'"
                  @click="() => deleteGroup(node, data)"
                  title="删除"
                ></el-button>
              </div>
            </span>
          </span>
        </element-tree-line>
      </template>
    </el-tree>
  </el-scrollbar>
</template>

<script>
import ElementTreeLine from "element-tree-line";
export default {
  components: {
    ElementTreeLine,
  },
  props: {
    treeData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      treeProps: {
        children: "integratedGroupChildren",
        label: "integratedGroupName",
        isLeaf: "isLeaf",
      },
      currentNode: "",
      expandedKeys: [],
    };
  },
  watch: {},
  methods: {
    stop(e) {
      e.stopPropagation();
    },
    addGroup(node, data) {
      const { integratedGroupCode } = data;
      this.$emit("on-group-add", integratedGroupCode);
    },
    deleteGroup(node, data) {
      const { integratedGroupCode } = data;
      this.$emit("on-group-delete", data);
    },
    editGroup(node, data) {
      const { hasLeaf, integratedGroupChildren, ...rest } = data;
      this.$emit("on-group-update", rest);
    },
    handleNodeClick(data, node, component) {
      const { integratedGroupCode } = data;
      this.currentNode = integratedGroupCode;
      this.$emit("node-click", data);
    },
    unfoldTree(newVal) {
      this.$nextTick(() => {
        this.expandedKeys = [newVal[0].integratedGroupCode];
        this.$refs.tree.setCurrentKey(newVal[0].integratedGroupCode);
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@src/common/assets/style/mixin";
.custom-tree-node {
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: 100%;
  .tree-label {
    max-width: 62%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .hide {
    max-width: 47% !important;
  }
  .tree-btn {
    position: absolute;
    right: 0;
  }
  .area-operator {
    display: inline-block;
    margin: 0 20px;
    .el-button {
      // color: #fff !important;
    }
  }
  .tree-icon {
    margin-right: 2px;
    @include set_theme_color(color, font-active-color);
  }
  .node-title {
    margin-bottom: -2px;
    display: inline-block;
    // width: 145px;
    margin-left: 4px;
    // white-space: nowrap;
    // text-overflow: ellipsis;
    // overflow: hidden;
    // word-break: break-all;
  }
}
.scroll-bar {
  height: 100%;
  // .tree-content {
  //   padding: 5px 0;
  //   /deep/.el-tree-node__content {
  //     &:hover {
  //       @include set_theme_color(background-color, main-theme-color);
  //       .el-button--text {
  //         color: #fff;
  //       }
  //     }
  //   }
  // }
  .el-scrollbar__wrap {
    overflow-x: hidden;
    height: 100%;
    margin-bottom: 0px !important;
  }
}
.custom-tree-node {
  display: flex;
  align-items: center;
  width: 100%;
  padding-right: 20px;
  justify-content: space-between;
}
</style>
